
export default function AboutSection() {
  const stats = [
    { number: '500+', label: 'Premium Brands' },
    { number: '10K+', label: 'Happy Customers' },
    { number: '15+', label: 'Years Experience' },
    { number: '24/7', label: 'Customer Support' }
  ];

  const values = [
    {
      icon: 'ri-award-line',
      title: 'Quality Assurance',
      description: 'We source only the finest beverages from trusted suppliers and maintain strict quality standards.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Trust & Reliability',
      description: 'Building lasting relationships through consistent service and dependable delivery commitments.'
    },
    {
      icon: 'ri-global-line',
      title: 'Local & International',
      description: 'Bridging local traditions with international excellence in our diverse product portfolio.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Customer First',
      description: 'Your satisfaction is our priority. We go above and beyond to exceed your expectations.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              About <span className="text-yellow-600">Cheers</span>
            </h2>
            <p className="text-xl text-gray-600 mb-6 leading-relaxed">
              Founded with a vision to become Ghana's leading and most trusted distributor of premium wines and spirits, 
              Cheers has been serving customers with excellence and dedication for over a decade.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We specialize in providing a wide range of high-quality alcoholic and non-alcoholic beverages, 
              featuring both local and international brands. Our commitment to quality, reliability, and exceptional 
              customer service has made us the preferred choice for businesses and individuals across Ghana.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl md:text-4xl font-bold text-yellow-600 mb-2">{stat.number}</div>
                  <div className="text-gray-600 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/0c484d07a320265448a3eb5af5955b16.jpg"
              alt="Cheers Warehouse"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
            <div className="absolute -bottom-6 -left-6 bg-yellow-400 rounded-2xl p-6 shadow-xl">
              <div className="text-black text-center">
                <div className="text-2xl font-bold">Our Mission</div>
                <div className="text-sm mt-2">Premium Quality<br />Exceptional Service</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-center text-black mb-12">
            Our <span className="text-yellow-600">Core Values</span>
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-black text-2xl`}></i>
                </div>
                <h4 className="text-xl font-bold text-black mb-3">{value.title}</h4>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-black rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Our <span className="text-yellow-400">Vision</span>
          </h3>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            "To become the leading and most trusted distributor of premium wine and spirits in Ghana, 
            setting the standard for quality, service, and customer satisfaction in the beverage industry."
          </p>
          <div className="mt-8 flex justify-center">
            <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-yellow-600"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
